<template>
  <div>
    <section>
      <h3 class="text-center">เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล</h3>
      <h5 class="text-right" style="font-size: 1rem;font-weight: bold;">วันที่ {{ toDate | prettyOnlyDate }}</h5>
    </section>

    <pre>
      ภายใต้ข้อตกลงการทำงาน บริษัท บีนีท จำกัด จำเป็นต้องเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคลบางประเภทของผู้ให้บริการที่อาจพิจารณาเป็นข้อมูลส่วนบุคคลอ่อนไหวตามนิยามที่ระบุไว้ในกฎหมายที่เกี่ยวข้อง หรือพิจารณาเป็นกิจกรรมที่มีความจำเป็นต้องได้รับความยินยอมจากท่าน บริษัทจึงมีจุดประสงค์ขอความยินยอมจากผู้ให้บริการ ทั้งนี้ บริษัทรับประกันจะประมวลผลข้อมูลส่วนบุคคลทั้งหมดตามเงื่อนไขนโยบายข้อมูลส่วนบุคคลสำหรับผู้ให้บริการที่บริษัทได้ประกาศไว้ 
    </pre>

    <pre>
      ข้าพเจ้า นาง/นางสาว <span>{{ professional.title_th }} {{ professional.firstname_th }} {{ professional.lastname_th }}</span> เกิดวันที่ <span class="font-weight-bold">{{ professional.birthday | prettyOnlyDate }}</span> บัตรประจำตัวประชาชนเลขที่ <span class="font-weight-bold">{{ professional.id_card_number }}</span> อยู่บ้านเลขที่ <span class="font-weight-bold">{{ professional.house_no }}</span> ถนน <span class="font-weight-bold">{{ professional.road }}</span> ตำบล/แขวง <span class="font-weight-bold">{{ professional.sub_district ? professional.sub_district.name_th : '-' }}</span> อำเภอ/เขต <span class="font-weight-bold">{{ professional.district ? professional.district.name_th : '-' }}</span> จังหวัด <span class="font-weight-bold">{{ professional.address_province ? professional.address_province.name_th : '-' }}</span> หมายเลขโทรศัพท์มือถือ <span class="font-weight-bold">{{ professional.phone ? '0' + professional.phone : '' }}</span> E-mail (ถ้ามี) <span class="font-weight-bold">{{ professional.email }}</span> หมายเลขผู้ให้บริการอิสระเลขที่ <span class="font-weight-bold">{{ professional.id }}</span>
    </pre>

    <pre>
      ทั้งนี้ ก่อนการแสดงเจตนา ข้าพเจ้าได้อ่านรายละเอียดจากเอกสารชี้แจงข้อมูล หรือได้รับคำอธิบายจากบริษัท บีนีท จำกัด ถึงนโยบายคุ้มครองข้อมูลส่วนบุคคลในการเก็บรวบรวม ใช้หรือเปิดเผย (“ประมวลผล”) ข้อมูลส่วนบุคคล และมีความเข้าใจดีแล้ว
    </pre>

    <pre>
[ ] ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ ข้อมูลศาสนา ประวัติอาชญากรรม และข้อมูลสุขภาพที่ปรากฏในใบสมัครงาน ประวัติ การฉีดวัคซีน Covid-19 รวมถึงผลตรวจ ATK เพื่อบริษัทจะได้ดำเนินการประเมินความเหมาะสมก่อน และระหว่าง การปฏิบัติงานให้บริการแก่ผู้ใช้บริการ และยินยอมให้บริษัทส่งต่อเปิดเผยข้อมูลดังกล่าว โดยเฉพาะข้อมูลสุขภาพให้แก่ ผู้ใช้บริการ เพื่อประโยชน์ในการเลือกใช้บริการ ซึ่งข้าพเจ้ารับทราบว่า ข้อมูลดังกล่าวถือเป็นเงื่อนไขสำคัญสำหรับการ ให้บริการผ่านทางแพลตฟอร์ม

[ ] ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ข้อมูลส่วนบุคคลของข้าพเจ้า ได้แก่ ภาพถ่าย ภาพเคลื่อนไหวของข้าพเจ้า เพื่อจัดทำสื่อ ประชาสัมพันธ์หลายรูปแบบของบริษัท

[ ] ข้าพเจ้ายินยอมให้บริษัทส่งต่อเปิดเผยข้อมูลส่วนบุคคลทั้งหมดของข้าพเจ้า รวมถึงแต่ไม่จำกัดเพียง ข้อมูลสุขภาพ และข้อมูลอื่นที่ ปรากฏตามใบสมัครงานแก่บริษัทในเครือ เพื่อให้บริษัทดังกล่าวใช้ข้อมูลนั้นมาติดต่อข้าพเจ้ากรณีมีตำแหน่งงานที่น่าสนใจ

[ ]	ข้าพเจ้า (1) เข้าใจและรับทราบนโยบายข้อมูลส่วนบุคคลผู้สมัครงานที่บริษัทประกาศ และ (2) รับรองว่าข้อมูลทั้งหมดที่ข้าพเจ้าให้ภายใต้ใบสมัครงานนั้นถูกต้องและเป็นจริง และสำหรับข้อมูลส่วนบุคคลของบุคคลอื่นที่ข้าพเจ้าได้นำส่งให้แก่บริษัท ข้าพเจ้ารับรองว่า ข้าพเจ้ามีสิทธิและ/หรือได้รับความยินยอมจากเจ้าของข้อมูลที่เกี่ยวข้องในการส่งต่อเปิดเผยข้อมูลของบุคคลดังกล่าวให้แก่บริษัทเพื่อประโยชน์ในการประมวลผลอย่างเหมาะสม
[ ] ข้าพเจ้าให้ความยินยอมในเอกสารนี้ด้วยความสมัครใจ ปราศจากการบังคับหรือชักจูง และข้าพเจ้าทราบว่าข้าพเจ้าสามารถถอนความยินยอมนี้เสียเมื่อใดก็ได้เว้นแต่ในกรณีมีข้อจำกัดสิทธิตามกฎหมายหรือยังมีสัญญาระหว่างข้าพเจ้ากับบริษัท บีนีท จำกัด ที่ให้ประโยชน์แก่ข้าพเจ้าอยู่

กรณีที่ข้าพเจ้าประสงค์จะขอถอนความยินยอม ข้าพเจ้าทราบว่าการถอนความยินยอมอาจจะมีผลทำให้ ข้าพเจ้าอาจได้รับความสะดวกในการใช้บริการน้อยลง หรือ ไม่สามารถเข้าถึงฟังก์ชันการใช้แพลตฟอร์มของบีนีทบางอย่างได้ เป็นต้น และข้าพเจ้าทราบว่าการถอนความยินยอมดังกล่าว ไม่มีผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ได้ดำเนินการเสร็จสิ้นไปแล้วก่อนการถอนความยินยอม
    </pre>

    <div class="text-right">
      <div class="d-inline-block">
        <div class="p-0">
          ลงชื่อ <span class="font-weight-bold">{{ professional.firstname_th }} {{ professional.lastname_th }}</span><br>
          ( <span class="font-weight-bold">{{ `${professional.title_th} ${professional.firstname_th} ${professional.lastname_th}` }}</span> )
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
export default {
  name: 'ConsentToDisClose',
  props: ['professional'],
  computed: {
    toDate () {
      return moment().format('YYYY-MM-DD')
    }
  }
}
</script>


<style scoped>
section pre {
  white-space: pre-wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/professional/contract/ConsentToDisClose.vue